import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useRouteMatch } from 'react-router-dom';

import appConfig from '../appConfig';
import { dispatchBettingAppMount } from '../utils/eventDispatchers';

const envs = {
	development: {
		css: [],
		js: [
			`${appConfig.wagering.baseUrl}/static/js/bundle.js`,
			`${appConfig.wagering.baseUrl}/static/js/vendors~main.chunk.js`,
			`${appConfig.wagering.baseUrl}/static/js/main.chunk.js`,
		],
	},
	production: {
		css: [`${appConfig.wagering.baseUrl}/static/css/bundle.css?t=${Date.now()}`],
		js: [`${appConfig.wagering.baseUrl}/static/js/bundle.js?t=${Date.now()}`],
	},
};

const Betting: React.FC = () => {
	const bettingRootRef = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		const env = envs[appConfig.env];
		const stylesheets: Array<HTMLLinkElement> = [];
		const scripts: Array<HTMLScriptElement> = [];

		if (env.css && env.css.length > 0) {
			env.css.forEach((url) => {
				const link = document.createElement('link');
				link.rel = 'stylesheet';
				link.href = url;
				document.body.appendChild(link);
				stylesheets.push(link);
			});
		}

		if (env.js && env.js.length > 0) {
			env.js.forEach((url) => {
				const script = document.createElement('script');
				script.async = true;
				script.src = url;

				document.body.appendChild(script);
				scripts.push(script);
			});
		}

		return () => {
			stylesheets.forEach((stylesheet) => stylesheet.remove());
			scripts.forEach((script) => script.remove());
		};
	}, []);

	const routeMatch = !!useRouteMatch('/betting');

	// Betting app is listening for this event to mount/unmount itself
	React.useEffect(() => {
		dispatchBettingAppMount(routeMatch);
	}, [routeMatch]);

	return (
		<>
			<Helmet title="Betting" />
			<div id="betting" ref={bettingRootRef} />
		</>
	);
};

export default Betting;
